<template>
  <article id="g-projects" class="g-container">
    <div>
      <Project
        title="Flutter Vignettes"
        imgName="tile-vignettes.png"
        description="17 beautiful, innovative Flutter UI explorations"
        alt="Mobile devices with UIs developed with Flutter Vignettes"
        href="/vignettes"
      />
      <Project
        title="Flutter Folio"
        imgName="tile-flutter-folio.png"
        description="Scrapbooking app tailored to mobile, desktop &amp; web"
        alt="A variety of devices running Flutter Folio"
        href="/folio"
      />
      <Project
        title="Flokk Contacts"
        imgName="tile-flokk.png"
        description="Social contact management on every desktop OS"
        alt="Screenshots of Flokk Contacts in dark and light mode"
        href="/flokk"
      />
      <Project
        title="Wonderous"
        imgName="tile-wonderous.jpg"
        description="A beautiful multi-platform mobile experience."
        alt="Screenshots of the Wonderous App on three devices"
        href="/wonderous"
      />
    </div>
  </article>
</template>

<script>
  import Project from "./Project.vue";

  export default {
    name: "Projects",
    components: {
      Project,
    },
  };
</script>

<style lang="scss" scoped>
  @import "../variables";

  .g-container {
    > div {
      max-width: 1200px;
      margin: auto;
    }
  }

  #g-projects {
    padding-top: pxToRem(40);
    padding-bottom: pxToRem(96);
    text-align: center;
    background: url("../assets/images/bg-bottom.png") repeat-x bottom;
    background-size: 1440px;
  }
</style>
